import { render, staticRenderFns } from "./addCashTransaction.vue?vue&type=template&id=06f3ed9e&scoped=true&"
import script from "./addCashTransaction.vue?vue&type=script&lang=js&"
export * from "./addCashTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f3ed9e",
  null
  
)

export default component.exports